import { Responsive } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import { IconHeartOn16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './Favorites.css';

export interface IFavoritesProps {
  onClick(event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>): void;
}

export const Favorites: React.FunctionComponent<IFavoritesProps> = ({ onClick }) => {
  return (
    <>
      <Responsive phone>
        <div className={styles['icon']} onClick={onClick}>
          <IconHeartOn16 color="error_100" />
        </div>
      </Responsive>
      <Responsive tablet>
        <Button size="XS" beforeIcon={<IconHeartOn16 color="primary_100" />} theme="stroke_primary" onClick={onClick}>
          В избранном
        </Button>
      </Responsive>
    </>
  );
};
